/* global ASP */

const { body } = document;

const portallinks = document.getElementsByClassName('headerlogin-navlinks');
[].forEach.call(portallinks, (elem) => {
	elem.classList.remove('exitNotifierLink');
	elem.classList.add('altExitNotifier');
});

// desktop menu detect click outside sub-menu to and close if outside
document.addEventListener('click', (event) => {
	const menuItems = document.querySelectorAll('.siteheader-li');
	menuItems.forEach((menuItem) => {
		menuItem.setAttribute('aria-expanded', 'false');
		menuItem.classList.remove('open');
	});

	if (event.target.getAttribute('aria-expanded') === 'true') {
		event.target.setAttribute('aria-expanded', 'false');
	} else {
		event.target.setAttribute('aria-expanded', 'true');
	}

	if (!event.target.closest('.headerlogin')) {
		const loginmenu = document.getElementById('headerlogin');
		body.classList.remove('submenu-open');
		loginmenu.classList.remove('open');
		loginmenu.focus();
	}

	if (!event.target.closest('.siteheader-li')) {
		if (!event.target.closest('.siteheader-submenu')) {
			const actives = document.getElementsByClassName('siteheader-submenu');
			body.classList.remove('submenu-open');
			[].forEach.call(actives, (elem) => {
				elem.classList.remove('open');
			});
		}
	}
}, false);

document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' || e.key === 'Esc') {
		const submenus = document.querySelectorAll('.siteheader-submenu');
		submenus.forEach((submenu) => {
			submenu.setAttribute('aria-expanded', 'false');
			submenu.classList.remove('open');
		});
	}
	const matches = e.target.matches ? e.target.matches('.siteheader-li') : e.target.msMatchesSelector('.siteheader-li');
	if (!matches) return;
	if (e.key === 'Enter') {
		const { target } = e;
		if (target.querySelector('.siteheader-submenu').classList.contains('open')) {
			target.querySelector('.siteheader-submenu').classList.remove('open');
		} else {
			target.querySelector('.siteheader-submenu').classList.add('open');
			target.querySelector('.siteheader-submenu-content').focus();
		}

		if (target.getAttribute('aria-expanded') === 'true') {
			target.setAttribute('aria-expanded', 'false');
		} else {
			target.setAttribute('aria-expanded', 'true');
		}
	}
});

document.addEventListener('keyup', (event) => {
	if (event.key === 'Enter') {
		if (event.target.classList.contains('button-login-desktop')) {
			const usernameField = document.querySelectorAll('.headerlogin #uname-header-desktop');
			usernameField[1].focus();
		}

		if (event.target.closest('.headerlogin')) {
			const loginmenu = document.getElementById('headerlogin');
			body.classList.remove('submenu-open');
			loginmenu.classList.add('open');
			loginmenu.focus();
		}
	}
}, false);

// desktop menu open and close submenu items
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.siteheader-li') : e.target.msMatchesSelector('.siteheader-li');
	if (!matches) return;
	e.preventDefault();

	const eleChild = e.target.querySelector('.siteheader-submenu');

	const loginmenu = document.getElementById('headerlogin');
	loginmenu.classList.remove('open');
	body.classList.remove('submenu-open');

	if (eleChild.classList.contains('open')) {
		eleChild.classList.remove('open');
		body.classList.remove('submenu-open');
	} else {
		const actives = document.getElementsByClassName('siteheader-submenu');
		[].forEach.call(actives, (elem) => {
			elem.classList.remove('open');
		});
		eleChild.classList.add('open');
		body.classList.add('submenu-open');
	}
}, false);


document.addEventListener('keydown', (e) => {
	const { target } = e;
	const shiftPressed = e.shiftKey;
	const focusableSelectors = 'a[href], input:not([disabled]), select:not([disabled]), button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	if (e.key === "Tab") {
		const dialog = target.closest('[role="dialog"]');
		if (dialog) {
			const focusableElements = Array.from(dialog.querySelectorAll(focusableSelectors)).filter((el) => el.offsetParent !== null);
			const first = focusableElements[0];
			const last = focusableElements[focusableElements.length - 1];
			if (shiftPressed) {
				if (target === first) {
					last.focus();
					e.preventDefault();
				}
			} else if (target === last) {
				first.focus();
				e.preventDefault();
			}
		}
	}

	if (e.key === 'Escape' || e.key === 'Esc') {
		const dialogs = document.querySelectorAll('div[role="dialog"]');
		dialogs.forEach((dlog) => {
			const loginMenu = dlog.closest('.headerlogin');
			if (loginMenu) {
				loginMenu.classList.remove('open');
			} else {
				dlog.closest('.siteheader-li').setAttribute('aria-expanded', 'false');
				dlog.classList.remove('open');
			}		// eslint-disable-next-line no-param-reassign
		});
	}
}, false);

document.addEventListener('keyup', (e) => {
	const matches = e.target.matches ? e.target.matches('.siteheader-search') : e.target.msMatchesSelector('.siteheader-search');
	if (!matches) return;
	e.preventDefault();

	if (e.key === 'Enter') {
		const eleChild = e.target.querySelector('.siteheader-submenu');

		const loginmenu = document.getElementById('headerlogin');
		loginmenu.classList.remove('open');
		body.classList.remove('submenu-open');

		if (eleChild.classList.contains('open')) {
			eleChild.classList.remove('open');
			body.classList.remove('submenu-open');
		} else {
			const actives = document.getElementsByClassName('siteheader-submenu');
			[].forEach.call(actives, (elem) => {
				elem.classList.remove('open');
			});
			eleChild.classList.add('open');
			body.classList.add('submenu-open');
		}
	}
}, false);

// open login menu
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.button-login-desktop') : e.target.msMatchesSelector('.button-login-desktop');
	if (!matches) return;
	e.preventDefault();

	const loginmenu = document.getElementById('headerlogin');

	if (loginmenu.classList.contains('open')) {
		loginmenu.classList.remove('open');
		body.classList.remove('submenu-open');
	} else {
		const actives = document.getElementsByClassName('siteheader-submenu');
		[].forEach.call(actives, (elem) => {
			elem.classList.remove('open');
		});

		loginmenu.classList.add('open');
		body.classList.add('submenu-open');
	}
}, false);

// close login menu
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.headerlogin-close') : e.target.msMatchesSelector('.headerlogin-close');
	if (!matches) return;
	e.preventDefault();

	const loginmenu = document.getElementById('headerlogin');
	loginmenu.classList.remove('open');
	body.classList.remove('submenu-open');
}, false);

// switch inner login menu
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.inner-switch') : e.target.msMatchesSelector('.innerswitch');
	if (!matches) return;
	e.preventDefault();

	const newTarget = e.target.getAttribute('data-inner');
	const newMenu = document.getElementById(newTarget);

	const opens = document.getElementsByClassName('headerlogin-rightinner');
	[].forEach.call(opens, (elem) => {
		elem.classList.remove('open');
	});

	const actives = document.getElementsByClassName('inner-switch');
	[].forEach.call(actives, (elem) => {
		elem.classList.remove('active');
	});

	e.target.classList.add('active');
	newMenu.classList.add('open');
}, false);

// open login menu on mobile
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.button-login-mobile') : e.target.msMatchesSelector('.button-login-mobile');
	if (!matches) return;
	e.preventDefault();

	const mainmenu = document.getElementById('headermobile-mainmenu');
	const loginmenu = document.getElementById('headermobile-loginmenu');
	const searchmenu = document.getElementById('headermobile-searchmenu');

	mainmenu.classList.remove('open');
	searchmenu.classList.remove('open');
	loginmenu.classList.add('open');
}, false);



// open search menu on mobile
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.button-search-mobile') : e.target.msMatchesSelector('.button-search-mobile');
	if (!matches) return;
	e.preventDefault();

	console.log('search');

	const mainmenu = document.getElementById('headermobile-mainmenu');
	const loginmenu = document.getElementById('headermobile-loginmenu');
	const searchmenu = document.getElementById('headermobile-searchmenu');

	mainmenu.classList.remove('open');
	loginmenu.classList.remove('open');
	searchmenu.classList.add('open');
}, false);

// adjust login menu height with slide in
const adjustLoginHeight = function () {
	const actives = document.getElementsByClassName('rightenter');
	const adjustDiv = actives[0];
	const height = adjustDiv.offsetHeight;

	document.getElementById('headermobile-loginmenu').setAttribute('style', `height:${height}px;`);
};

// slide login mobile menu in
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.loginmenu-slide') : e.target.msMatchesSelector('.loginmenu-slide');
	if (!matches) return;
	e.preventDefault();

	const slideData = e.target.getAttribute('data-menu');
	const newMenu = document.getElementById(slideData);

	newMenu.classList.add('rightenter');

	adjustLoginHeight();
}, false);

// slide login mobile menu out
document.addEventListener('click', (e) => {
	const matches = e.target.matches ? e.target.matches('.loginmobile-back') : e.target.msMatchesSelector('.loginmobile-back');
	if (!matches) return;
	e.preventDefault();

	const activemenus = document.getElementsByClassName('rightenter');
	[].forEach.call(activemenus, (elem) => {
		elem.classList.remove('rightenter');
	});

	document.getElementById('headermobile-loginmenu').setAttribute('style', 'height:auto;');
}, false);


// slide mobile menu views in and out
const adjustHeight = function () {
	const actives = document.getElementsByClassName('activemenu');
	const adjustDiv = actives[0];
	const height = adjustDiv.offsetHeight;

	document.getElementById('headermobile-menu').setAttribute('style', `height:${height}px;`);
};

const resetMenu = function () {
	setTimeout(() => {
		// remove 'activemenu' from current menu screen
		const activemenus = document.getElementsByClassName('activemenu');
		[].forEach.call(activemenus, (elem) => {
			elem.classList.remove('activemenu');
		});

		// move all menus to right
		const deepmenus = document.getElementsByClassName('headermobile-deep');
		[].forEach.call(deepmenus, (elem) => {
			elem.classList.remove('rightenter');
		});

		// add 'activemenu' to the top menu
		const topMenus = document.getElementsByClassName('headermobile-topmenu');
		const topMenu = topMenus[0];
		topMenu.className += ' activemenu';

		// reset login menu
		const mainmenu = document.getElementById('headermobile-mainmenu');
		const loginmenu = document.getElementById('headermobile-loginmenu');

		loginmenu.classList.remove('open');
		mainmenu.classList.add('open');
		const loginmenus = document.getElementsByClassName('rightenter');
		[].forEach.call(loginmenus, (elem) => {
			elem.classList.remove('rightenter');
		});
		document.getElementById('headermobile-loginmenu').setAttribute('style', 'height:auto;');

		adjustHeight();
	}, 500);
};

document.addEventListener('click', (e) => {
	if (!e.target.matches('.headermobile-menulink')) return;
	e.preventDefault();

	const actives = document.getElementsByClassName('activemenu');
	[].forEach.call(actives, (elem) => {
		elem.classList.remove('activemenu');
	});

	const child = e.target.getAttribute('data-child');
	const newActive = document.getElementById(child);
	newActive.className += ' rightenter activemenu';

	adjustHeight();
}, false);


document.addEventListener('click', (e) => {
	if (!e.target.matches('.topreturn')) return;
	e.preventDefault();

	const actives = document.getElementsByClassName('activemenu');
	[].forEach.call(actives, (elem) => {
		elem.classList.remove('activemenu');
		elem.classList.remove('rightenter');
	});

	const topMenus = document.getElementsByClassName('headermobile-topmenu');
	const topMenu = topMenus[0];
	topMenu.className += ' activemenu';

	adjustHeight();
}, false);


document.addEventListener('click', (e) => {
	if (!e.target.matches('.returnmiddle')) return;
	e.preventDefault();

	const actives = document.getElementsByClassName('activemenu');
	[].forEach.call(actives, (elem) => {
		elem.classList.remove('activemenu');
		elem.classList.remove('rightenter');
	});

	const parent = e.target.getAttribute('data-parent');
	const newActive = document.getElementById(parent);
	newActive.className += ' activemenu';

	adjustHeight();
}, false);

// mobile menu activate
document.addEventListener('click', (e) => {
	var viewportHeight = window.innerHeight + "px";
	if (!e.target.matches('.menu-activate')) return;
	e.preventDefault();

	const menus = document.getElementsByClassName('headermobile-maincontainer');
	const menu = menus[0];
	menu.className += ' active';
	menu.setAttribute('style', `max-height:${viewportHeight}`);
}, false);

document.addEventListener('click', (e) => {
	if (!e.target.matches('.nav-close')) return;
	e.preventDefault();

	// close nave by removing 'active' class
	const actives = document.getElementsByClassName('headermobile-maincontainer');
	[].forEach.call(actives, (elem) => {
		elem.classList.remove('active');
	});
	document.getElementById('headermobile-maincontainer').setAttribute('style', 'max-height:0');

	resetMenu();
}, false);

adjustHeight();

// window.addEventListener('scroll', () => {
// 	if (ASP) {
// 		ASP.api(0, 'closeResults');
// 	}
// });

// Can change placeholder on smaller device?
// const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
// if (viewportWidth < 1000) {
// 	document.getElementsByName('phrase')[0].placeholder = 'Search...';
// }
const loadSiteHeaderSize = () => {
  const siteheaders = document.querySelectorAll(".siteheader");

  if (!siteheaders.length > 2) {
    setTimeout(checkSiteHeaderAndScroll, 100); // Check again after 100ms
    return;
  }

  siteheaders.forEach((siteheader) => {
    if (window.getComputedStyle(siteheader)['display'] === "none") {
      return;
    }
    window.siteHeaderHeight = siteheader.offsetHeight;
    document.documentElement.style.scrollPaddingTop = `${siteheader.offsetHeight}px`;
  })

}
loadSiteHeaderSize();